import {useCallback, useEffect, useMemo} from 'react'
import {RenderComponent} from 'src/biz/common/renderComponent'
import {formatFormJsonValue} from 'src/biz/utils'
import {Button, Form} from 'src/ui'
import Provider from 'src/ui/Provider'
import locale from 'src/ui/locale'
import type {baseComponentType} from '../types'
import styles from './index.module.scss'

locale.DatePicker.lang = {
  ...locale.DatePicker.lang,
  shortMonths: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  shortWeekDays: ['日', '一', '二', '三', '四', '五', '六'],
}
export interface SearchComponentProps {
  data: baseComponentType[]
  submit?: (data: any) => void
  export?: (data?: any) => void
  add?: () => void
  reset?: (data: any) => void
  onChange?: (data: any) => void
}

// table search组件
const SearchComponent: React.FC<SearchComponentProps> = props => {
  const {data} = props
  const [form] = Form.useForm()
  const Controls = data.map((comp: baseComponentType, index: number) => {
    const dataProps = {
      ...comp,
    }
    const propsWidth = dataProps.width ? `${dataProps.width}px` : '246px'
    const propsHeight = dataProps.height ? `${dataProps.height}px` : '32px'
    dataProps.style = {width: propsWidth, height: propsHeight}
    if (!comp.prefix && (comp.type === 'Input' || !comp.type)) {
      //input默认prefix
      dataProps.prefix = <img src="https://hd-static.yystatic.com/7310634584966429.png" className={styles.prefixIcon} />
      dataProps.style = {...dataProps.style, padding: '5px 12px'}
    }
    if (dataProps.type === 'RangePicker') {
      dataProps.style = {width: dataProps.width ? `${dataProps.width}px` : '380px', height: '32px'}
    }
    dataProps.variant = 'filled'
    const watchItem = comp.watchKey
      ? JSON.stringify(Form.useWatch(comp.watchKey, form)) === JSON.stringify(comp.watchValue)
      : true
    Reflect.deleteProperty(dataProps, 'initialValue')
    Reflect.deleteProperty(dataProps, 'watchKey')
    Reflect.deleteProperty(dataProps, 'watchValue')

    if (watchItem) {
      return (
        <Form.Item
          name={comp.name as string}
          label={comp.label}
          key={index as any}
          className={styles.searchFormItem}
          initialValue={comp.initialValue}
          rules={comp.rules}
        >
          <RenderComponent {...dataProps} />
        </Form.Item>
      )
    } else {
      return null
    }
  })

  const handleSearch = () => {
    // const formValue = formatFormValue()
    const formValue = form.getFieldsValue()
    console.log('handleSearch formValue', formValue)
    props.submit?.(formValue)
  }
  const reset = () => {
    form.resetFields()
    // const formValue = formatFormValue()
    handleSearch()
  }
  const onChange = () => {
    // const formValue = formatFormValue()
    const formValue = form.getFieldsValue()
    console.log('onChange formValue', formValue)
    props.onChange && props.onChange(formValue)
  }
  const formatFormValue = () => {
    const value = form.getFieldsValue()
    const data = formatFormJsonValue(props.data, value)
    return data
  }
  const handleExport = () => {
    props.export?.()
  }
  return (
    <Provider locale={locale}>
      <div className={styles.container}>
        <Form form={form} layout={'inline'} className={styles.searchForm} onValuesChange={onChange}>
          {Controls}
        </Form>
        <div className={styles.btnList}>
          <Button onClick={handleSearch}>查询</Button>
          <Button color={'default'} variant={'filled'} onClick={reset}>
            重置
          </Button>
          {props.export && (
            <Button onClick={handleExport} className={styles.reset}>
              导出
            </Button>
          )}
        </div>
      </div>
    </Provider>
  )
}
export default SearchComponent
